import React from 'react';
import {
  EmbedFooterContainer,
  EmbedFooterLink,
  EmbedFooterLinkTitle,
  EmbedFooterLogoContainer,
} from './EmbedFooter';
import SVGIcon from '../../components/SVGIcon';
import slabIcon from '../../icons/prefilled/slab.svg';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import postPath, { publicPostPath } from '../../utils/url/postPath';
import useIsPublicView from '../../utils/useIsPublicView';
import {
  isAllowedThroughLinkAccess,
  PostPolicyAction,
} from '../../post/postPolicyCheck';
import { UserRole } from '../../topic/topicPolicyCheck';

const POST_EMBED_FOOTER_POST_FRAGMENT = gql(`
  fragment PostEmbedFooter_post on PublicPostFields {
    id
    title
    ...postPath_post
    ...isAllowedThroughLinkAccess_post
  }
`);

interface PostEmbedFooterProps {
  post: DocumentType<typeof POST_EMBED_FOOTER_POST_FRAGMENT>;
}

const PostEmbedFooter = ({ post }: PostEmbedFooterProps) => {
  const isPublicView = useIsPublicView();

  const isPublic = post
    ? isAllowedThroughLinkAccess(
        PostPolicyAction.ViewPost,
        post,
        UserRole.Anonymous,
      )
    : false;

  const path = isPublicView && isPublic ? publicPostPath(post) : postPath(post);

  return (
    <EmbedFooterContainer>
      <EmbedFooterLink link={path}>
        <EmbedFooterLogoContainer>
          <SVGIcon size={16}>{slabIcon}</SVGIcon>
        </EmbedFooterLogoContainer>
        <EmbedFooterLinkTitle>{post.title}</EmbedFooterLinkTitle>
      </EmbedFooterLink>
    </EmbedFooterContainer>
  );
};

export default PostEmbedFooter;
